import { render, staticRenderFns } from "./simplifyOwnerRooms.vue?vue&type=template&id=9b892c24&scoped=true"
import script from "./simplifyOwnerRooms.vue?vue&type=script&lang=js"
export * from "./simplifyOwnerRooms.vue?vue&type=script&lang=js"
import style0 from "./simplifyOwnerRooms.vue?vue&type=style&index=0&id=9b892c24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_a6c7c6c484daeff6636bea47b922569f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b892c24",
  null
  
)

export default component.exports